import useSearchFilter from "hooks/useSearchFilter";
import RangeFilter from "./RangeFilter";
import { generateBuyPriceList } from "utils/searchFilter";
import { useState } from "react";
import { ReactComponent as PriceFilterIcon } from "assets/icons/property_type_filter.svg";

const PriceFilter = () => {
  const { priceMin, priceMax, setPriceMin, setPriceMax } = useSearchFilter();
  const [priceOptions, setPriceOptions] = useState(generateBuyPriceList());

  return (
    <RangeFilter
      id="price"
      placeholder="Prezzo"
      options={priceOptions}
      unit="€"
      paramMin="priceMin"
      paramMax="priceMax"
      minValue={priceMin}
      maxValue={priceMax}
      setMinValue={setPriceMin}
      setMaxValue={setPriceMax}
      Icon={PriceFilterIcon}
    />
  );
};

export default PriceFilter;
